var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 75H35C28.108 75 22.5 69.392 22.5 62.5V47.5H27.5V62.5C27.5 66.6357 30.8643 70 35 70H55C59.1357 70 62.5 66.6357 62.5 62.5V45H67.5V62.5C67.5 69.392 61.892 75 55 75Z",
    fill: "#2AA7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40C14.0892 40 6.06798 32.1045 5.73248 31.7675L9.26773 28.2323C9.33248 28.2958 16.199 34.9998 25.0002 34.9998C33.8015 34.9998 40.668 28.2958 40.7362 28.2285L44.2677 31.7673C43.932 32.1043 35.9105 40 25 40Z",
    fill: "#2AA7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C13.9723 50 5 41.0277 5 30V16.4037C5 12.9552 7.3365 9.96321 10.6813 9.12721L16.8935 7.57446L18.107 12.4255L11.8948 13.9782C10.779 14.2565 10.0003 15.254 10.0003 16.4037V30C10.0003 38.2715 16.7288 45 25.0003 45C33.2718 45 40.0003 38.2715 40.0003 30V16.4037C40.0003 15.2537 39.2215 14.2565 38.1058 13.9782L31.8935 12.4255L33.107 7.57446L39.3193 9.12721C42.664 9.96346 45.0005 12.9552 45.0005 16.4037V30C45.0005 41.0277 36.0278 50 25 50Z",
    fill: "#2AA7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15C16.1195 15 15 13.8805 15 12.5V7.5C15 6.1195 16.1195 5 17.5 5C18.8805 5 20 6.1195 20 7.5V12.5C20 13.8805 18.8805 15 17.5 15Z",
    fill: "#2AA7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 15C31.1195 15 30 13.8805 30 12.5V7.5C30 6.1195 31.1195 5 32.5 5C33.8805 5 35 6.1195 35 7.5V12.5C35 13.8805 33.8805 15 32.5 15Z",
    fill: "#2AA7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47.5C59.486 47.5 55 43.014 55 37.5C55 31.986 59.486 27.5 65 27.5C70.514 27.5 75 31.986 75 37.5C75 43.014 70.514 47.5 65 47.5ZM65 32.5C62.2425 32.5 60 34.7425 60 37.5C60 40.2575 62.2425 42.5 65 42.5C67.7575 42.5 70 40.2575 70 37.5C70 34.7425 67.7575 32.5 65 32.5Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.63f1d7810f15899025b2941d65014a51.svg";
export { ForwardRef as ReactComponent };